import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { IconButton, Snackbar, SnackbarContent } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import CloseIcon from '@material-ui/icons/Close';
import WarningIcon from '@material-ui/icons/Warning';
import InfoIcon from '@material-ui/icons/Info'; // Jeino
import { green, orange } from '@material-ui/core/colors';
import { withStyles } from '@material-ui/core/styles';
import { alertActions } from '../../_global/_actions';

const variantIcon = {
    success: CheckCircleIcon,
    error: ErrorIcon,
    warning: WarningIcon,
    info: InfoIcon // Jeino
};

const styles1 = theme => ({
    success: {
        backgroundColor: green[600],
    },
    error: {
        backgroundColor: theme.palette.error.dark,
    },
    warning: {
        backgroundColor: orange[600],
    },
    // Jeino
    info: {
        backgroundColor: theme.palette.primary.dark,
    },
    icon: {
        fontSize: 20,
    },
    iconVariant: {
        opacity: 0.9,
        marginRight: 8,
    },
    message: {
        display: 'flex',
        alignItems: 'center',
    },
});

function MySnackbarContent(props) {
    const { classes, className, message, onClose, variant, ...other } = props;
    const Icon = variantIcon[variant];

    return (
        <SnackbarContent
            aria-describedby="client-snackbar"
            className={classNames(classes[variant], className)}
            message={
                <span id="client-snackbar" className={classes.message}>
                    <Icon className={classNames(classes.icon, classes.iconVariant)} />
                    {message}
                </span>
            }

            action={
                [
                    <IconButton
                        key="close"
                        aria-label="Close"
                        color="inherit"
                        className={classes.close}
                        onClick={onClose}
                    >
                        <CloseIcon className={classes.icon} />
                    </IconButton>,
                ]}

            headlinemapping={{
                body1: "div",
                body2: "div"
            }}
            {...other}
        />
    );
}

MySnackbarContent.propTypes = {
    classes: PropTypes.object.isRequired,
    className: PropTypes.string,
    message: PropTypes.node,
    onClose: PropTypes.func,
    variant: PropTypes.oneOf(['success', 'error', 'warning', 'info']).isRequired,
};

const MySnackbarContentWrapper = withStyles(styles1)(MySnackbarContent);

const styles2 = theme => ({
    margin: {
        margin: 8,
    },
});

class SuccessMsg extends React.Component {
    handleCloseSuccessMsg = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        this.props.dispatch(alertActions.hide(this.props.type));
    }

    render() {
        const { classes, show, message, type, hideDuration } = this.props;

        return (
            <div>
                <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    open={show}
                    autoHideDuration={hideDuration ? hideDuration : 3000}
                    onClose={this.handleCloseSuccessMsg}
                    disableWindowBlurListener={true}
                >
                    <MySnackbarContentWrapper
                        onClose={this.handleCloseSuccessMsg}
                        variant={type}
                        className={classes.margin}
                        message={message}
                    />
                </Snackbar>
            </div>
        );
    }
}

SuccessMsg.propTypes = {
    classes: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    const { show, message, type, hideDuration } = state.alert;
    return {
        show, message, type, hideDuration
    };
}

export default connect(mapStateToProps)(withStyles(styles2)(SuccessMsg))
